import { Tickets } from "../models/Ticket";
import FBIHttp from "./FBIHttp";

export interface ObtencaoDeTicketsOutput extends Tickets{}

class NeoassistService {


  
  private static readonly baseUrl = '/api/bi/Neoassist';

  public static obterListaDeSolicitacao = async (): Promise<any> => FBIHttp.get(`${this.baseUrl}/`);

  public static obterListaDeSolicitantes = async (valor?: string | null): Promise<any> => FBIHttp.get(`${this.baseUrl}/usuarios?input=${valor}`);

  public static criarSolicitacao = async (input: any): Promise<ObtencaoDeTicketsOutput> => FBIHttp.post(this.baseUrl, input);
  
  public static sincronizar = async (): Promise<ObtencaoDeTicketsOutput> => FBIHttp.post(`${this.baseUrl}/sincronizar`);
}

export default NeoassistService;